import React from 'react';
import useGoogleWebSiteDataJson from '../useHooks/useGoogleWebSiteDataJson';
import { JsonLd } from 'react-schemaorg';

const GoogleWebSiteData = () => {
  return <JsonLd item={useGoogleWebSiteDataJson()} />;
};

export default GoogleWebSiteData;
